import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { ENVIRONMENT } from '@environment';
import {
    getParams,
    StoreService,
} from '@my-aon/shared';
import { DevExtremeData, hasValue } from '@my-aon/utils';
import { AuthenticationService, IRole } from '@my-aon/auth';
import { PermissionViewModel } from '../models/permission-view.model';

@Injectable({
    providedIn: 'root',
})
export class RolesService {

    readonly environment = inject(ENVIRONMENT);
    readonly http: HttpClient = inject(HttpClient);
    private readonly path: string = this.environment.apiUrl + 'Admin/Roles/';

    readonly store = inject(StoreService);
    readonly auth = inject(AuthenticationService);
    readonly translateService = inject(TranslateService);

    $roles = signal<IRole[]>([]);
    $permissions = signal<PermissionViewModel[]>([]);

    constructor() {
        this.reloadRoles();

        this.http.get<DevExtremeData<{ Key: string }>>(`${this.environment.apiUrl}Admin/Permissions`)
            .pipe(map((result: DevExtremeData<{ Key: string }>) => {
                const map = (item: { Key: string }) => {

                    let prefix = item.Key.split('.')[0];
                    let label = this.translateService.instant(`PERMISSIONS.PERMISSION.${item.Key}`);
                    let description = this.translateService.instant(`PERMISSIONS.PERMISSION.${item.Key}_DESCRIPTION`);
                    if (description == `PERMISSIONS.PERMISSION.${item.Key}_DESCRIPTION`) description = null;

                    return new PermissionViewModel({
                        prefix: prefix as 'sys' | 'geral' | 'hw' | 'auto_fleet',
                        key: item.Key,
                        label,
                        description,
                    });
                }
                return (result.data as Array<{ Key: string }>).map(map)
            }))
            .subscribe(result => this.$permissions.set(result));
    }

    private reloadRoles() {

        let params: any = getParams({ sort: [{ selector: 'Name', desc: false }] });
        this.http.get<DevExtremeData<IRole>>(this.path, { params })
            .subscribe((result) => {
                this.$roles.set(result.data as IRole[]);
            });

    }


    public byKey(key: string): Observable<IRole> {
        return this.http.get<IRole>(`${this.path}${key}`);
    }

    public getEligibleRolesForUser(
        userId?: string,
        isExternal?: boolean
    ): Observable<IRole[]> {
        let params = new HttpParams();
        if (!hasValue(userId) && hasValue(isExternal))
            params = params.append('isExternal', isExternal);
        return this.http.get<IRole[]>(
            `${this.path}Eligible/${hasValue(userId) ? 'ByUser/' + userId : ''}`,
            { params }
        );
    }

    public insertOrUpdate(model: IRole, original: IRole): Observable<IRole> {

        const result = () => {
            if (!hasValue(model.Id) || !hasValue(original.Id))
                return this.http.post<IRole>(this.path, model);
            else
                return this.http.patch<IRole>(`${this.path}${model.Id}`, model);
        };

        return result().pipe(tap(() => this.reloadRoles()));
    }

}
